import { TableCell } from '@mui/material'
import dayjs from 'dayjs'
import React, { useMemo } from 'react'
import { VACATION_PROJECT_NAME } from '../../../store/constants/projectAcronyms'
import { Column, WorkDay } from '../../../store/types'
import DateFormat from '../../../store/types/enums/DateFormat'
import { sumProjectPerDay } from '../../../store/utils'
import { roundUpToNearestMinute } from '../../../store/utils/worklogUtils'
import DecimalHourDurationTooltip from '../../Tooltip/DecimalHourDurationTooltip'

type WorklogColumnCellProps = {
  column: Column
  worklog: WorkDay[] | undefined
  date: dayjs.Dayjs
}

const WorklogColumnCell = ({ column, worklog, date }: WorklogColumnCellProps) => {
  const todaysTotal = useMemo(() => {
    return roundUpToNearestMinute(
      sumProjectPerDay(
        worklog,
        column.projectId,
        date.format(DateFormat.YearMonthDay),
        date.format(DateFormat.YearMonthDay)
      )
    )
  }, [worklog, column.projectId, date])

  return (
    <TableCell
      sx={{
        flex: 1,
        visibility: column.label !== VACATION_PROJECT_NAME ? 'visible' : 'hidden',
      }}
      align="center"
    >
      {todaysTotal === 0 ? (
        '-'
      ) : (
        <DecimalHourDurationTooltip hours={todaysTotal} arrow>
          <span>{todaysTotal}</span>
        </DecimalHourDurationTooltip>
      )}
    </TableCell>
  )
}

export default React.memo(WorklogColumnCell)
